/**
 * A single row in the po deep dive table
 */

import React from "react"
import PropType from "prop-types"
import { TableRow, TableCell } from "@amzn/meridian/table"
import Text from "@amzn/meridian/text"
import PropTypes from "prop-types";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import EventIcon from "../../event/event-icon";
import { getDisplayQuantity, getChildAsin } from "../../../utilities/parent-child-conversion";


const NyrTableRow = props => {
  const { nyrItem, criticalAsinEvents, region_id } = props

  // Use backend-provided child quantities or fall back to parent quantities
  const convertedQuantityConfirmed = getDisplayQuantity(nyrItem.quantityConfirmed || 0, nyrItem.child_quantity_confirmed);
  const convertedQuantityReceived = getDisplayQuantity(nyrItem.quantityReceived || 0, nyrItem.child_quantity_received);
  const nyrQuantity = convertedQuantityConfirmed - convertedQuantityReceived < 0 ? 0 : convertedQuantityConfirmed - convertedQuantityReceived;

  const criticalEvents = nyrItem.criticalEvent ? criticalAsinEvents ?
    criticalAsinEvents.filter((criticalAsinEvent) => nyrItem.criticalEvent.includes(criticalAsinEvent.eventName))
    : [] : [];
  return (
    <TableRow key={nyrItem.asin}>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrItem.tempZone ? nyrItem.tempZone : ""}>
          {nyrItem.tempZone ? nyrItem.tempZone : ""}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Column>
          <Text tag="p" children={nyrItem.asin ? nyrItem.asin : ""}>
            {nyrItem.asin ? nyrItem.asin : ""}
          </Text>
          {criticalEvents.length > 0 &&
            <Row alignmentHorizontal="center">
              {criticalEvents.map(criticalEvent => <EventIcon event={criticalEvent.eventName} regionId={region_id} />)}
            </Row>
          }
        </Column>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={getChildAsin(nyrItem) || ""}>
          {getChildAsin(nyrItem) || ""}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrItem.asinTitle ? nyrItem.asinTitle : "Unknown Title"}>
          {nyrItem.asinTitle ? nyrItem.asinTitle : "Unknown Title"}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrItem.quantityConfirmed || 0}>
          {(nyrItem.quantityConfirmed || 0).toLocaleString()}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={convertedQuantityConfirmed}>
          {convertedQuantityConfirmed.toLocaleString()}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={convertedQuantityReceived}>
          {convertedQuantityReceived.toLocaleString()}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrQuantity}>
          {nyrQuantity.toLocaleString()}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrItem.isCriticalAsin}>
          {nyrItem.isCriticalAsin}
        </Text>
      </TableCell>
      <TableCell alignmentHorizontal="center">
        <Text tag="p" children={nyrItem.isAsrsAsin}>
          {nyrItem.asrsEligible != null && nyrItem.asrsEligible === 1 ? "Y" : "N"}
        </Text>
      </TableCell>
    </TableRow>
  )
}

NyrTableRow.propTypes = {
  nyrItem: PropType.object.isRequired,
  rowComponents: TableRow.propTypes.rowComponents,
  criticalAsinEvents: PropTypes.object.isRequired,
  region_id: PropTypes.number.isRequired,
}

export default NyrTableRow
